import { createAction, props } from '@ngrx/store';
import { Brand } from '../../models/dbmodels';

export const loadBrands = createAction('[Brand] Load Brands');

export const loadBrandsSuccess = createAction(
  '[Brand] Load Brands Success',
  props<{ brands: Brand[] }>() // The successful payload will be an array of brands
);
export const loadBrandsFailure = createAction(
  '[Brand] Load Brands Failure',
  props<{ error: any }>() // Handle errors
);
